import React from 'react';
import InfoLogin from '../SignUp/Info';
import TsAndCs from '../Text';
import './style.scoped.scss';

const AccountPagesWrapper = ({
  children,
  hideText = false,
  noContainer = false,
  isRegister = false,
  signupForm,
  className,
}) => {
  return isRegister ? (
    <div className='wf-background'>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <div className='containers'>
          <div className='leftSide' id='left-side-registration'>
            <div className='info'>
              <InfoLogin />
            </div>
          </div>
          <div className='rigthSide'>
            <div className='wf-account container'>{signupForm}</div>
          </div>
        </div>
        <div
          className='w-100'
          style={{
            marginTop: '4rem',
          }}
        >
          <TsAndCs />
        </div>
      </div>
    </div>
  ) : (
    <div className='wf-background'>
      <div
        className={`wf-account${noContainer ? ' p-4' : ' container'} ${
          className ? className : ''
        }`}
      >
        {children}
        {/* {hideText ? null : <TsAndCs />} */}
      </div>
    </div>
  );
};

export default AccountPagesWrapper;
